module.exports = __webpack_public_path__ + "static/media/mobile-valet.94966253.png";